export default {
      id: "ic-nav-swiper-prev-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-nav-swiper-prev-usage",
      toString: function () {
        return this.url;
      }
    }